import { useState } from 'react';
import { Link } from 'react-scroll';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { getNavbarList } from '@/components/houses/_constants';
import { useMidTermQuery } from '../../_hooks/useMidterm';
import Icon from '@/components/UI/icon/Icon';
import Box from '@/components/UI/box/Box';
import Typography from '@/components/UI/typography/Typography';
import styles from './NavbarMobile.module.scss';
import { ProductItemTypes } from '../../_types/productItem.types';
const NavbarMobile = ({
  productState,
  handleFavorite,
  isBookmarked,
  handleOpenShare,
  handleBack
}: {
  productState: ProductItemTypes;
  handleFavorite: () => void;
  isBookmarked: boolean;
  handleOpenShare: (name: string) => void;
  handleBack: () => void;
}) => {
  const [showNavbar, setShowNavbar] = useState<boolean>(false);
  const [showheader, setShowheader] = useState<boolean>(false);
  const {
    isMidTerm
  } = useMidTermQuery(productState);
  useScrollPosition(({
    currPos,
    prevPos
  }) => {
    if (currPos.y <= -150) {
      if (currPos.y > prevPos.y) {
        setShowheader(true);
      } else {
        setShowheader(false);
      }
    } else {
      setShowheader(false);
    }
    if (currPos.y <= -300) {
      setShowNavbar(true);
    } else {
      setShowNavbar(false);
    }
  });
  return <Box component="section" className={`${styles['navbar-mobile']} ${showheader ? styles['navbar-mobile-header'] : ''}`} data-sentry-element="Box" data-sentry-component="NavbarMobile" data-sentry-source-file="NavbarMobile.tsx">
      <Box className={styles['navbar-mobile-top-section']} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
        <Box className={styles['back-icon']} onClick={handleBack} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
          <Icon className="icon" name="arrow-right-1" type="inherit" size={'xLarge'} data-sentry-element="Icon" data-sentry-source-file="NavbarMobile.tsx" />
        </Box>

        <Box className={styles['bookmark-share-icon']} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
          <Box className={styles['bookmark-icon']} onClick={handleFavorite} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
            <Icon name={isBookmarked ? 'heart-Filled' : 'heart'} type={isBookmarked ? 'error' : 'highEmphasis'} data-sentry-element="Icon" data-sentry-source-file="NavbarMobile.tsx" />
          </Box>

          <Box className={styles['share-icon']} onClick={() => handleOpenShare('SHARE')} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
            <Icon name={'share'} type="highEmphasis" data-sentry-element="Icon" data-sentry-source-file="NavbarMobile.tsx" />
          </Box>
        </Box>
      </Box>
      <Box className={`${styles['navbar-mobile-bottom-section']} ${showNavbar ? styles['navbar-mobile-show-navbar'] : ''}`} data-sentry-element="Box" data-sentry-source-file="NavbarMobile.tsx">
        {getNavbarList(!isMidTerm).map(item => <Link key={item.link} activeClass={styles['active']} smooth spy offset={item.link === 'calendar' ? -70 : -130} to={item.link} className={styles['navbar-links']}>
            <Box className={styles['border-top']}></Box>
            <Typography variant="bodyL" className={styles['links']}>
              {item.title}
            </Typography>
          </Link>)}
      </Box>
    </Box>;
};
export default NavbarMobile;